export default __webpack_public_path__ + "static/media/avatar.a75427b7.png";